<div>
  <div>
    <mat-form-field>
      <mat-label>Slug</mat-label>
      <input matInput [(ngModel)]="slug" required />
    </mat-form-field>
  </div>

  <gymfinder-search-filter-text
  [(languageText)]="text"></gymfinder-search-filter-text>

  <div>
    <mat-form-field appearance="fill" class="synonyms-field">
      <mat-label>Synonyms</mat-label>

      <mat-chip-grid #synonymsList aria-label="Filter synonyms">
        @for (synonym of synonyms; track synonym) {
          <mat-chip-row
            (removed)="removeSynonym(synonym)">
            {{ synonym }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
        <input
          placeholder="New synonym..."
          [matChipInputFor]="synonymsList"
          (matChipInputTokenEnd)="addSynonym($event)" />
      </mat-chip-grid>
    </mat-form-field>
  </div>

  <gymfinder-block
    [studioTypes]="studioTypes"
    [activities]="activities"
    [services]="services"
    [gymTypes]="gymTypes"
    [gymEquipments]="gymEquipments"
    [equipmentsToBring]="equipmentsToBring"
    [gymInfos]="gymInfos"
    [networks]="networks"
    [geniusFeatures]="geniusFeatures"
  [(block)]="block"></gymfinder-block>
</div>
